module.exports = "https://health.dajiuxing.com.cn/img/components/img/close.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=components%2Fimg%2Fclose.png
// module id = MvDn
// module chunks = 93